module.exports = __webpack_public_path__ + "img/skypets-3.a1e803de.jpg";